import { Button } from "@/components/ui/button";
import { cn } from "@/utils/cn";
import { formatMinorAmount } from "@/utils/formatMinorAmount";
import { Check } from "@pkg/icons";

interface AppliedPromoCodeProps {
  message?: string;
  code: string;
  percent_off?: number | null;
  amount_off?: number | null;
  isSticky?: boolean;
  isRemoving?: boolean;
  onRemove?: () => void;
  currency?: string;
}

/**
 * Green success banner that displays an applied coupon code
 * with an optional "Remove" action.
 */
export function AppliedPromoCode({
  message = "coupon applied!",
  code,
  percent_off,
  amount_off,
  isSticky,
  isRemoving = false,
  onRemove,
  currency,
}: AppliedPromoCodeProps) {
  const isPreApplied = !!isSticky;

  const discountValue = percent_off
    ? `${percent_off}%`
    : amount_off
      ? formatMinorAmount(amount_off, currency)
      : null;

  return (
    <div id="Promo-Code-Applied-El" className="w-full">
      <div className="@container inline-flex h-10 w-full items-center gap-2 rounded-lg border-[#3E8174] bg-[#3E81741A] px-2">
        {!isPreApplied && <Check className={cn("h-4 w-4 text-[#3E8174]")} />}

        <div className="flex flex-1 items-center gap-2">
          <span className="font-archivo text-xs leading-5 font-normal text-[#3E8174] uppercase @sm:text-sm">
            {code}
          </span>

          {onRemove && (
            <Button
              variant="inline-accent"
              onClick={onRemove}
              disabled={isRemoving}
            >
              {isRemoving ? "Removing..." : "Remove"}
            </Button>
          )}
        </div>
        {discountValue && (
          <div className="text-[#3E8174]">-{discountValue}</div>
        )}
      </div>
    </div>
  );
}
